/**
 * Splits an array into smaller chunks of a specified size.
 *
 * @template T The type of elements in the array
 * @param {T[]} array The array to be chunked
 * @param {number} size The size of each chunk
 * @returns {T[][]} An array of chunks, where each chunk is an array of size elements
 *
 * @example
 * chunk([1, 2, 3, 4, 5], 2)
 * // Returns: [[1, 2], [3, 4], [5]]
 *
 * @example
 * chunk(['a', 'b', 'c'], 3)
 * // Returns: [['a', 'b', 'c']]
 */
export const chunk = <T>(array: T[], size: number): T[][] => {
  if (size <= 0) {
    return []
  }

  const result: T[][] = []
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size))
  }
  return result
}
